import { IKnmEventPeriodExtension } from 'APIPackage/KnmModule/interfaces/IKnmEventPeriodExtension';
import { IKnmPmFormExtension } from 'KnmPmPackage/PmExtensionModule/interfaces/IKnmPmFormExtension';
import { convertInitialKnmDateToFormDate } from 'KnmPackage/MainModule/common/convertInitialKnmDateToFormDate';
import {
  DATE_FORMAT_ISO_FNS,
  DATE_FORMAT_LONG_FNS,
  DATE_FORMAT_LONG_MINUTE_FNS,
} from 'CorePackage/MainModule/constants/dateFormats';

export const convertEventExtensionToFormData = (
  periodExtension: IKnmEventPeriodExtension | null,
): IKnmPmFormExtension | undefined => {
  if (!periodExtension) {
    return undefined;
  }

  return {
    guid: periodExtension.guid || undefined,
    dateCreate: periodExtension.dateCreate || undefined,
    attachment: periodExtension.attachment || undefined,
    decisionNumber: periodExtension.decisionNumber || undefined,
    decisionDateTime: convertInitialKnmDateToFormDate(
      periodExtension.decisionDateTime,
      DATE_FORMAT_LONG_MINUTE_FNS,
      DATE_FORMAT_ISO_FNS,
    ),
    amountDays: typeof periodExtension.amountDays === 'number' ? String(periodExtension.amountDays) : undefined,
    isWorkDaysOnly: true,
    initiationDate: convertInitialKnmDateToFormDate(periodExtension.initiationDate, DATE_FORMAT_LONG_FNS),
  };
};
